import React from 'react';
import PropTypes from 'prop-types';
import LocalizedLink from 'helpers/LocalizeLink';
import Picture from 'components/elements/Picture';
import { useSelector } from 'react-redux';

function HeaderHomeBoxWidget(props) {
    const auth = useSelector(store => store.auth)

    return (
        <>
            <div className="text_part col-md-5 col-lg-6 text-sm-center">
                {props.title ? <h1 data-test-id="header-title" className="text-color-changeable mb-20">{props.title}</h1> : null}
                {props.descriptions ? <p data-test-id="header-description" className="text-white text-sm-medium text-semibold mb-20">{props.descriptions}</p> : null}
                {props.additional_text ? <p data-test-id="header-add-text" className="text-color-changeable text-sm-medium text-semibold text-italic mb-20">{props.additional_text}</p> : null}
                {
                    props.button_text && props.link ? (
                        auth && (props.link === '/auth' || props.link === 'auth') ?
                        (
                            <LocalizedLink dti="header-btn" to={'/price'} className="btn btn-dark h-42 px-12 text-medium text-semibold">
                                {props.button_text}
                            </LocalizedLink>
                        ) : (
                            <LocalizedLink dti="header-btn" to={props.link ? props.link : null} className="btn btn-dark h-42 px-12 text-medium text-semibold">
                                {props.button_text}
                            </LocalizedLink>
                        ) 
                    ) : null
                }
            </div>
            {
                props.img || props.img_mob ?
                    <div className="head_logo col-md-7 col-lg-6 d-flex align-items-center">
                        <Picture dti="header-img" img={props.img} img_mob={props.img_mob} className="w-100" />
                    </div> : null
            }
        </>
    )
}

HeaderHomeBoxWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    link: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.object,
    position: PropTypes.number,
    widget: PropTypes.string,
    className: PropTypes.string,
};

export default HeaderHomeBoxWidget;
